<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="任务类型" prop="type">
                <el-select v-model="queryCondition.type" clearable filterable placeholder="请选择" style="width:100%">
                  <el-option :key="index" v-for="(item, index) in typeLists" :label="item" :value="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="任务名称" prop="name">
                <el-input v-model="queryCondition.name" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建日期从" prop="createDateFrom">
                <el-date-picker style="width: 100%" v-model="queryCondition.createDateFrom" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建日期至" prop="createDateTo">
                <el-date-picker style="width: 100%" v-model="queryCondition.createDateTo" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
          </el-row>
        </el-form>
      </div>
      <el-table :data="tableData" border max-height="650" highlight-current-row>
        <el-table-column show-overflow-tooltip sortable prop="flowName" label="任务流程" min-width="130"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="typeName" label="类型" min-width="160"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="name" label="任务名称" min-width="140"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="createDate" label="待办任务创建时间" min-width="100" align="center"></el-table-column>
        <el-table-column show-overflow-tooltip sortable label="操作" min-width="120">
          <template slot-scope="scope">
            <el-button size="mini" @click="audit(scope.row.flowName, scope.row)" type="primary">处理</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import taskApi from "../../../api/myTask";
import commonFunction from "@/utils/dataTableUtils";
import prot3p from "@/api/rmcProtein/prot3p";

export default {
  name: "",
  components: {},
  data() {
    return {
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        createDateFrom: "",
        createDateTo: "",
        name: "",
        type: "",
      },
      tableData: [],
      typeLists: [],
      totalCount: 0,
      labelPosition: "right",
    };
  },
  created() {
    this.queryData();
    this.getQspiToDoType();
  },
  methods: {
    queryData() {
      if (
        this.queryCondition.createDateFrom === null ||
        this.queryCondition.createDateFrom === undefined
      ) {
        this.queryCondition.createDateFrom = "";
      }
      if (
        this.queryCondition.createDateTo === null ||
        this.queryCondition.createDateTo === undefined
      ) {
        this.queryCondition.createDateTo = "";
      }
      if (
        this.queryCondition.name === null ||
        this.queryCondition.name === undefined
      ) {
        this.queryCondition.name = "";
      }
      if (
        this.queryCondition.type === null ||
        this.queryCondition.type === undefined
      ) {
        this.queryCondition.type = "";
      }
      taskApi
        .getQspiToDoLists(
          this.queryCondition.createDateFrom,
          this.queryCondition.createDateTo,
          this.queryCondition.name,
          this.queryCondition.type,
          this.queryCondition.pageNum,
          this.queryCondition.pageSize
        )
        .then((res) => {
          this.tableData = res.resultData;
          this.totalCount = res.totalCount;
        });
    },
    getQspiToDoType() {
      taskApi.getQspiToDoType().then((res) => {
        console.log("res", res);
        this.typeLists = res;
      });
    },
    audit(flowName, row) {
      console.log("flowName", flowName);
      console.log("rowrowrow", row);

      switch (flowName) {
        case "QIP":
          if (row.type == "QIP_CHECK") {
            this.$router.push({
              path: `/qspiQIP`,
              query: {
                month: row.params.YEAR_MONTH,
                status: JSON.stringify(["SUBMITTED"]),
              },
            });
          } else if (row.type == "QIP_SCORE") {
            taskApi
              .cancelQspiToDo(row.type, row.params.YEAR_MONTH)
              .then((res) => {
                console.log("res", res);
                if (res.meta.code == 200) {
                  this.queryData();
                }
              });
          } else if (row.type == "QIP_FEEDBACK") {
            this.$router.push({
              path: `/qspiQIP`,
              query: {
                month: row.params.YEAR_MONTH,
                status: JSON.stringify(["CHECK"]),
              },
            });
          } else if (row.type == "QIP_CONCLUSION") {
            this.$router.push({
              path: `/qspiQIP`,
              query: {
                month: row.params.YEAR_MONTH,
                status: JSON.stringify([
                  "OBJECTION_HAVE_BEEN_FEEDBACK",
                  "TIMED_OUT",
                ]),
              },
            });
          } else if (row.type == "QIP_FSC_FEEDBACK") {
            // 跳转QIP页面TO_BE_FSC_ISSUED
            this.$router.push({
              path: `/qspiQIP`,
              query: {
                month: row.params.YEAR_MONTH,
                code: row.params.QIP_CODE,
                fscType: "TO_BE_FSC_ISSUED"
              },
            });
          } else if (row.type == "QIP_CQS_FEEDBACK") {
            // 跳转QIP页面TO_BE_CQS_ISSUED
            this.$router.push({
              path: `/qspiQIP`,
              query: {
                month: row.params.YEAR_MONTH,
                category2: row.params.CATEGORY2_CODE,
                cqsType: "TO_BE_CQS_ISSUED"
              },
            });
          } else {
            this.$router.push({
              path: `/qspiQIP/detail`,
              query: {
                ttQspiQipId: row.params.BIZ_ID,
                from: "edit",
              },
            });
          }
          break;
        case "FSPI":
          this.$router.push({
            path: `/qspiFSPI`,
            query: {
              month: row.params.YEAR_MONTH,
            },
          });
          break;
        case "DQMP":
          this.$router.push({
            path: `/qspiDQMP`,
            query: {
              month: row.params.YEAR_MONTH,
            },
          });
          break;
        case "QBR计划":
          this.$router.push({
            path: `/qspiQBRPlan`,
            query: {
              category2CodesList: row.params.CATEGORY2_CODE,
              year: row.params.YEAR,
            },
          });
          break;
        case "QBR":
          var year = row.params.YEAR_MONTH.split("-")[0];
          this.$router.push({
            path: `/qspiQBR/detail`,
            query: {
              ttQspiQbrDetailId: row.params.BIZ_ID,
              month: row.params.YEAR_MONTH,
              year: year,
              from: "todo",
            },
          });
          break;
        case "QSPI其他类":
          var type = row.params.FACTOR_TYPE;
          var category2 = row.params.CATEGORY2_CODE;
          var month = row.params.YEAR_MONTH;
          console.log("type", type);
          if (type === "MSV") {
            this.$router.push({
              path: `/qspiMSV`,
              query: {
                type: type,
                month: month,
              },
            });
          } else if (type === "SWA") {
            this.$router.push({
              path: `/qspiSWA`,
              query: {
                type: type,
                month: month,
              },
            });
          } else if (type === "SQMS") {
            this.$router.push({
              path: `/qspiSQMS`,
              query: {
                type: type,
                month: month,
                category2: category2,
              },
            });
          } else if (type === "GOVT_CERT") {
            this.$router.push({
              path: `/qspiGovtCert`,
              query: {
                type: type,
                month: month,
              },
            });
          } else if (type === "SPEC_COMPLIANCE") {
            this.$router.push({
              path: `/qspiSpecCompliance`,
              query: {
                type: type,
                month: month,
                category2: category2,
              },
            });
          } else if (type === "COA") {
            this.$router.push({
              path: `/qspiCOA`,
              query: {
                type: type,
                month: month,
              },
            });
          } else if (type === "REG_COMPLIANCE") {
            this.$router.push({
              path: `/qspiRegCompliance`,
              query: {
                type: type,
                month: month,
                category2: category2,
              },
            });
          } else if (type === "GOVT_PLANT_AUDIT") {
            this.$router.push({
              path: `/qspiGovtPlantAudit`,
              query: {
                type: type,
                month: month,
                category2: category2,
              },
            });
          } else if (type === "STOCK_RECOVERY") {
            this.$router.push({
              path: `/qspiOtherStockRecovery`,
              query: {
                type: type,
                month: month,
              },
            });
          } else if (type === "PRODUCT_FEEDBACK") {
            this.$router.push({
              path: `/qspiProductFeedback`,
              query: {
                type: type,
                month: month,
              },
            });
          } else if (type === "SENSORY") {
            this.$router.push({
              path: `/qspiSensory`,
              query: {
                type: type,
                month: month,
              },
            });
          } else if (type === "ANTIBIOTIC_CHICKEN") {
            this.$router.push({
              path: `/qspiAntiChick`,
              query: {
                type: type,
                month: month,
              },
            });
          } else if (type === "QBR") {
            this.$router.push({
              path: `/qspiOtherQBR`,
              query: {
                type: type,
                month: month,
              },
            });
          }
          break;
        case "AAA评分":
          if (row.type == "AAA_SCORE") {
            //供应商评分
            let obj = {
              isCanAudit: true,
            };
            sessionStorage.setItem("taskDetail", JSON.stringify(obj));
            this.$router.push({
              path: `/aaaMarkSheet`,
              query: {
                id: row.params.BIZ_ID,
              },
            });
          } else if (row.type == "AAA_SCORE_CQS") {
            //cqs评分
            let obj = {
              isCanAudit: true,
            };
            sessionStorage.setItem("taskDetail", JSON.stringify(obj));
            this.$router.push({
              path: `/aaaMarkSheet`,
              query: {
                id: row.params.BIZ_ID,
              },
            });
          } else if (row.type == "AAA_SCORE_OWNER") {
            //owner复核
            this.$router.push({
              path: `/qspiAAASummary`,
              query: {
                appraisePeriod: row.params.APPRAISE_PERIOD,
              },
            });
          } else if (
            row.type == "AAA_SCORE_RECT" ||
            row.type == "AAA_SCORE_RECT_CONF"
          ) {
            //待供应商整改
            let obj = {
              isCanAudit: true,
            };
            sessionStorage.setItem("taskDetail", JSON.stringify(obj));
            this.$router.push({
              path: `/sponsormarkSheet`,
              query: {
                id: row.params.BIZ_ID,
              },
            });
          } else if (row.type == "AAA_SCORE_RECT)CONF") {
            //待cqs确认整改
            let obj = row;
            obj.ttQspiAaaScoreId = row.params.BIZ_ID;
            obj.isCanAudit = true;
            sessionStorage.setItem("taskDetail", JSON.stringify(obj));
            this.$router.push({
              path: `/sponsormarkSheet`,
            });
          }
          break;
        case "RMC Produce 农场清单":
          this.$router.push({
            path: `/rmcProdFarm`,
            query: {
              sponsorName: row.params.SPONSOR_NAME,
              auditStatus: row.params.AUDIT_STATUS,
              type: row.type,
            },
          });
          break;
        case "RMC Protein 农场清单":
          this.$router.push({
            path: `/rmcProtFarm`,
            query: {
              sponsorName: row.params.SPONSOR_NAME,
              auditStatus: row.params.AUDIT_STATUS,
              type: row.type,
            },
          });
          break;
        case "RMC Protein 饲料厂清单":
          this.$router.push({
            path: `/rmcProtFeedPlant`,
            query: {
              status: row.params.AUDIT_STATUS,
              sponsorName: row.params.SPONSOR_NAME,
              sponsorCode: row.params.SPONSOR_CODE,
              type: row.type,
            },
          });
          break;
        case "RMC Produce 审核员清单":
          this.$router.push({
            path: `/rmcProdAuditor`,
            query: {
              sponsorName: row.params.SPONSOR_NAME,
              auditStatus: row.params.AUDIT_STATUS,
              type: row.type,
            },
          });
          break;
        case "RMC Protein 审核员清单":
          this.$router.push({
            path: `/rmcProtAuditor`,
            query: {
              sponsorName: row.params.SPONSOR_NAME,
              auditStatus: row.params.AUDIT_STATUS,
              type: row.type,
            },
          });
          break;
        case "RMC Produce 采购量":
          this.$router.push({
            path: `/rmcProdPcQty`,
            query: {
              month: row.params.YEAR_MONTH,
              // status: "DRAFT",
              sponsorName: row.name.split("：")[1].split(")")[0],
            },
          });
          break;
        case "RMC Protein 采购量":
          this.$router.push({
            path: `/rmcProtPcQty`,
            query: {
              month: row.params.YEAR_MONTH,
              // status: "DRAFT",
              sponsorName: row.name.split("：")[1].split(")")[0],
            },
          });
          break;
        case "RMC Protein 评分":
          let num = "";
          if (row.type == "RMC_PROTEIN_SCORE") {
            num = "1";
          } else if (row.type == "RMC_PROTEIN_SCORE_COMMIT") {
            num = "2";
          } else if (row.type == "RMC_PROTEIN_SCORE_REJECT") {
            num = "3";
          }
          this.$router.push({
            path: `/rmcProtScore`,
            query: {
              appraisePeriod: row.params.APPRAISE_PERIOD,
              sponsorName: row.params.SPONSOR_NAME,
              status: num,
            },
          });
          break;
        case "RMC Produce 评分":
          let getStatus = "";
          if (row.type == "RMC_PRODUCE_SCORE") {
            getStatus = "1";
          } else if (row.type == "RMC_PRODUCE_SCORE_COMMIT") {
            getStatus = "2";
          } else if (row.type == "RMC_PRODUCE_SCORE_REJECT") {
            getStatus = "3";
          }
          this.$router.push({
            path: `/rmcProdScore`,
            query: {
              appraisePeriod: row.params.APPRAISE_PERIOD,
              sponsorName: row.params.SPONSOR_NAME,
              status: getStatus,
            },
          });
          break;
        case "RMC Protein 药品清单":
          row.params.type = row.type
          sessionStorage.setItem("qspiInfo", JSON.stringify(row.params));
          this.$router.push({
            path: `/rmcProtMedicine`,
            query: {},
          });
          break;
        case "RMC Protein 药品用量":
          sessionStorage.setItem("qspiInfo", JSON.stringify(row.params));
          this.$router.push({
            path: `/rmcProtMedUsage`,
            query: {},
          });
          break;
        case "RMC Protein 月度药品用量":
          sessionStorage.setItem("qspiInfo", JSON.stringify(row.params));
          this.$router.push({
            path: `/rmcProtMedUsage`,
            query: {},
          });
          break;
        case "RMC Produce 药品清单":
          sessionStorage.setItem("qspiInfo", JSON.stringify(row.params));
          this.$router.push({
            path: `/rmcProdMedicine`,
            query: {},
          });
          break;
        case "RMC Produce 药品用量":
          sessionStorage.setItem("qspiInfo", JSON.stringify(row.params));
          this.$router.push({
            path: `/rmcProdMedUsage`,
            query: {},
          });
          break;
        case "RMC Protein ASL审核报告":
          sessionStorage.setItem("qspiInfo", JSON.stringify(row.params));
          // if (row.type == "RMC_PROTEIN_AUDIT_REPORT") {
          //   prot3p.completeTaskTodo(row.ttQspiTodoId).then((res) => {
          //     console.log("ssssssss", res);
          //   });
          // }
          this.$router.push({
            path: `/rmcProt3P`,
            query: {},
          });
          break;
      }
    },
    onReset() {
      this.$refs["queryCondition"].resetFields();
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        createDateFrom: "",
        createDateTo: "",
        name: "",
        type: "",
      };
      this.queryData();
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val;
      this.queryData();
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val;
      this.queryData();
    },
  },
  extends: commonFunction,
};
</script>
<style scoped></style>
